import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
} from 'react';
import apiClient from '../data/apiClient';
//import menuDataResponse from '../data/mocks/menuDataResponse.json';

//import _ from 'lodash';

const HeaderFooterContext = createContext();

const headerFooterProviderDispatchAction = {
  FETCH_DATA: 'FETCH_DATA',
};

const HeaderFooterProvider = ({ children }) => {
  const [headerJson, setHeaderJson] = useState();
  const [dataLoading, setDataLoading] = useState(false);

  const semaphore = useRef(true);

  const headerFooterCallback = useCallback(
    async (action) => {
      switch (action) {
        case headerFooterProviderDispatchAction.FETCH_DATA:
          if (semaphore.current && !headerJson) {
            setDataLoading(true);
            semaphore.current = false;
            try {
              const response = await apiClient.getHeaderFooterData();
              setHeaderJson(response.data);
              //setHeaderJson(menuDataResponse);
            } catch (e) {
              //setError('Napaka pri pridobivanju podatkov. Prosimo poskusite kasneje.');
            } finally {
              semaphore.current = true;
              setDataLoading(false);
            }
          }
          break;

        default:
          throw new Error(
            'Invalid action used for EpgProvider dispatchCallback.'
          );
      }
    },
    [headerJson]
  );

  // use object value structure if you want to extract values in nondeterministic order otherwise use an array
  return (
    <HeaderFooterContext.Provider
      value={{ dataLoading, headerJson, headerFooterCallback }}
    >
      {children}
    </HeaderFooterContext.Provider>
  );
};

const useHeaderFooterContext = () => {
  const context = useContext(HeaderFooterContext);
  if (context === undefined) {
    throw new Error('useHeaderFooterContext must be used within a EpgProvider');
  }
  return context;
};

export {
  HeaderFooterProvider,
  useHeaderFooterContext,
  headerFooterProviderDispatchAction,
};
